/**
 * Product info drawer - right-sliding panel
 * Horizontal tabs: Details, Beyond Eyewear, Shipping & Returns
 */
class ProductInfoDrawer extends HTMLElement {
  constructor() {
    super();
    this.moved = false;
    this.bound = false;
  }

  connectedCallback() {
    if (!this.moved) {
      this.moved = true;
      if (this.parentNode !== document.body) {
        document.body.appendChild(this);
        return;
      }
    }

    if (this.bound) return;
    this.bound = true;

    this.overlay = this.querySelector('.product-info-drawer__overlay');
    this.panel = this.querySelector('.product-info-drawer__panel');
    this.titleEl = this.querySelector('.product-info-drawer__title');
    this.closeBtn = this.querySelector('.product-info-drawer__close');

    this.overlay?.addEventListener('click', () => this.close());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close());

    document.querySelectorAll('.product-info-tabs:not(.product-info-drawer__footer) .product-info-tabs__trigger').forEach((btn) => {
      btn.addEventListener('click', (e) => this.open(e.currentTarget));
    });

    this.querySelectorAll('.product-info-drawer__footer .product-info-tabs__trigger').forEach((btn) => {
      btn.addEventListener('click', (e) => this.switchPanel(e.currentTarget));
    });
  }

  getPanelTitle(panelId) {
    const titles = {
      'details': document.querySelector('.product-info-tabs:not(.product-info-drawer__footer) [data-panel="details"] span:first-child')?.textContent || 'Details',
      'size-guide': document.querySelector('.product-info-tabs:not(.product-info-drawer__footer) [data-panel="size-guide"] span:first-child')?.textContent || 'Beyond Eyewear',
      'delivery-returns': document.querySelector('.product-info-tabs:not(.product-info-drawer__footer) [data-panel="delivery-returns"] span:first-child')?.textContent || 'Shipping'
    };

    return titles[panelId] || panelId;
  }

  setExpandedPanel(panelId) {
    document.querySelectorAll('.product-info-tabs__trigger').forEach((b) => {
      const isActive = b.dataset.panel === panelId;
      b.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  }

  open(trigger) {
    const panelId = trigger?.dataset?.panel;
    if (!panelId) return;

    const contentEl = document.getElementById('product-info-panel-' + panelId);
    if (!contentEl) return;

    this.querySelectorAll('.product-info-panel').forEach((p) => p.setAttribute('hidden', ''));
    contentEl.removeAttribute('hidden');

    this.titleEl.textContent = this.getPanelTitle(panelId);
    this.setExpandedPanel(panelId);

    this.classList.add('active');
    document.body.classList.add('product-info-drawer-open', 'overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('product-info-drawer-open', 'overflow-hidden');
    document.querySelectorAll('.product-info-tabs__trigger').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }

  switchPanel(trigger) {
    const panelId = trigger?.dataset?.panel;
    if (!panelId) return;

    const contentEl = document.getElementById('product-info-panel-' + panelId);
    if (!contentEl) return;

    this.querySelectorAll('.product-info-panel').forEach((p) => p.setAttribute('hidden', ''));
    contentEl.removeAttribute('hidden');

    this.titleEl.textContent = this.getPanelTitle(panelId);
    this.setExpandedPanel(panelId);
  }
}

customElements.define('product-info-drawer', ProductInfoDrawer);
